import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nameResolver'
})

export class NameResolverPipe implements PipeTransform {
    transform(value: any): string {
        let sep = ', ';
        if (!value || value.indexOf(sep)==-1)
            return value;
        let first = value.substring(value.indexOf(sep)+sep.length);
        let last = value.substring(0, value.indexOf(sep));
        return first + ' ' + last;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/name-resolver.pipe.ts